import React from 'react';
import { generateClassName } from './helpers';

const GenericTabPanel = ({ children, value, index, className }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
        >
            {value === index && (
                <div className={generateClassName('generic', '-tab-content', className)}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default GenericTabPanel;